$(document).ready(function(){
$('.testimonials_slider').slick({
    dots: false,
    autoplay: true,
    arrows:false,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
     responsive: [
    {
      breakpoint: 990,
       settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

  
  });
$(document).ready(function(){
      // $('.readmore').insertAfter( '.product-description' );

        $('.readmore').click(function (event) {
          event.preventDefault();
          var description = document.querySelector('.product-description');
          console.log(description.style.height)
          if (description.style.height === ''){
            description.style.height = 'auto';
          } else if (description.style.height === 'auto'){
            description.style.height = '';
          }
          else{
            description.style.height = '92px';
          }

          $(this).text($(this).text() == 'Read less...' ? 'Read more...' : 'Read less...');
        });
});